import React, { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import classnames from 'classnames';

import './GuidanceLabel.scss';
import Icon, { IconName } from '../../../common/components/icon/Icon';

export interface GuidanceLabelProps
  extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  icon?: IconName;
  children?: ReactNode;
}

const GuidanceLabel = ({
  className,
  icon,
  children,
  ...props
}: GuidanceLabelProps) => {
  return (
    <div className={classnames('guidance-label', className)} {...props}>
      {icon && <Icon className="guidance-label__icon" name={icon} />}
      <span className="guidance-label__text">{children}</span>
    </div>
  );
};

export default GuidanceLabel;
